import React from 'react';
import { Box, Grid2, styled, Typography } from '@mui/material';
import CustomIcon from '../../../Components/CustomIcon';


const RedirectBlock = styled(Grid2)(() => ({
    borderRadius: '16px',
    backgroundColor: '#F9F9F9',

    "&:hover": {
        color: "#4D44D8 !important",

        "& .MuiTypography-root": {
            color: "#4D44D8 !important",
        },
        "& .MuiSvgIcon-root path": {
            fill: "#4D44D8 !important",
        }
    }
}));


const NoDataOnChart = ({ isDataEmpty, onClick, disableRedirect = false, noDataMessage = 'No data available for the selected date' }) => {
    if (!isDataEmpty) {
        return null;
    }

    return (
        <Box sx={{ zIndex: 1, position: 'absolute', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography variant="fw500s14c494949" sx={{
                    fontWeight: 400,
                    fontSize: '12px',
                    lineHeight: '24px',
                    padding: '2px 12px',
                    color: '#494949',
                    borderRadius: '16px',
                    background: '#F9F9F9'

                }} > {noDataMessage} </Typography>
            </Grid2>
            {!disableRedirect && <Grid2 container justifyContent={'center'} alignItems={'center'} sx={{
                marginTop: '2px',
            }}>
                <RedirectBlock container
                    justifyContent={'center'}
                    alignItems={'center'}
                    gap={'8px'}
                    sx={{ cursor: 'pointer', marginTop: '16px', py: 0.5, px: 1 }}
                    onClick={() => onClick()}
                >
                    <CustomIcon fontSize="24px" name='clock-arrow-icon' />
                    <Typography variant="fw500s14c494949" sx={{ lineHeight: '16px' }} > Redirect to Latest Recorded Data </Typography>
                </RedirectBlock>
            </Grid2>
            }
        </Box>
    )
}


export default NoDataOnChart;
